import { render, staticRenderFns } from "./add-template.vue?vue&type=template&id=764803ba&scoped=true&"
import script from "./add-template.vue?vue&type=script&lang=js&"
export * from "./add-template.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "764803ba",
  null
  
)

export default component.exports